import { render, staticRenderFns } from "./configurePeriodGraph.vue?vue&type=template&id=0fcd1857&scoped=true&"
import script from "./configurePeriodGraph.vue?vue&type=script&lang=js&"
export * from "./configurePeriodGraph.vue?vue&type=script&lang=js&"
import style0 from "./configurePeriodGraph.vue?vue&type=style&index=0&id=0fcd1857&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcd1857",
  null
  
)

export default component.exports